export default __webpack_public_path__ + "static/char-v-16-aeffd7da07be3886f8c31096408ca46c.mp4";